import React, { useState, useEffect } from "react";
import { Table, Modal, Button, Row, Col, Input, message, Menu, Tag, Tooltip, Card, Select, DatePicker, Divider, Dropdown, Checkbox } from "antd";
import { FileExcelOutlined, InfoCircleOutlined, SettingOutlined, CheckOutlined, EditOutlined } from "@ant-design/icons";
import moment from "moment";
import * as XLSX from "xlsx";
import { debounce } from "lodash";
import ManagerService from "../../services/ManagerService";

const QuanLyDonCongNoComponent = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingKey, setEditingKey] = useState(null);
    const [editedValues, setEditedValues] = useState({});
    const [manualInputKyPs, setManualInputKyPs] = useState("");
    const [openPicker, setOpenPicker] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [lichSuThanhToan, setLichSuThanhToan] = useState([]);
    const [soTienThanhToan, setSoTienThanhToan] = useState("");
    const [isPaying, setIsPaying] = useState(false);
    const [filterDate, setFilterDate] = useState(null);
    const [filterSoTien, setFilterSoTien] = useState(null);
    const [selectedKyPs, setSelectedKyPs] = useState(null);
    const [selectedDichVu, setSelectedDichVu] = useState(null);
    const [visibleColumns, setVisibleColumns] = useState([
        "ma_hd", "don_vi", "ky_ps", "dich_vu", "ma_nv", "tuyen_sale", "ma_khach_hang", "ten_don_vi", "tong_cong_no", "phan_loai", "thoi_han", "cong_no_ton", "giai_trinh"
    ]);

    //Lấy danh sách các đơn công nợ
    useEffect(() => {
        const fetchCongNoData = async () => {
            setLoading(true);
            try {
                const response = await ManagerService.getDanhSachCongNo();
                const cleanData = response.data.map(item => ({
                    ...item,
                    ky_ps: moment(item.ky_ps, "ddd, DD MMM YYYY HH:mm:ss [GMT]").format("YYYY-MM-DD")
                }));
                setData(cleanData);
                setFilteredData(cleanData);                
            } catch (error) {
                message.error("Lỗi khi lấy dữ liệu công nợ");
            } finally {
                setLoading(false);
            }
        };
        fetchCongNoData();
    }, []);

    // State lưu danh sách các nhân viên sale
    const [Ds_nv, SetDs_nv] = useState([]);
    // State lưu danh sách khách hàng (mảng chứa { ma_khach_hang, ten_don_vi })
    const [dsKhachHang, setDsKhachHang] = useState([]);
    // Gọi API lấy danh sách khách hàng từ bảng don_vi_kinh_doanh và  Danh sách sale từ bảng user
    useEffect(() => {
        const fetchDsKhachHang = async () => {
            try {
                const response = await ManagerService.getDonViKinhDoanh();
                if (response.success) {
                setDsKhachHang(response.data);
                }
            } catch (error) {
                console.error('Lỗi khi lấy DS khách hàng:', error);
            }
        };
        const fetchDsSale = async () => {
            try {
                const response = await ManagerService.Lay_DS_Sale();
                console.log(response);
                if (response && response.data) {
                    const options = response.data.map(item => ({
                      ma_nv: item.username,
                      tuyen_sale: item.name,
                    }));
                    SetDs_nv(options);
                  }
            } catch (error) {
                console.error('Lỗi khi lấy DS khách hàng:', error);
            }
        };

        fetchDsKhachHang();
        fetchDsSale();
    }, []);
    {/* Khi người dùng chọn Tuyến sale, tự động cập nhật mã nhân viên */}
    // Dùng cho chế độ Edit cả dòng
    const handleTuyenSaleChangeRow = (value) => {
        const selectedSale = Ds_nv.find(nv => nv.tuyen_sale === value);
        setEditedValues({
            ...editedValues,
            tuyen_sale: value,
            ma_nv: selectedSale ? selectedSale.ma_nv : ""
        });
    };
    // Dùng cho chế độ Edit từng ô (cell)
    const handleTuyenSaleChangeCell = async (record, tuyen_sale) => {
        const selectedSale = Ds_nv.find(nv => nv.tuyen_sale === tuyen_sale);
        const ma_nv = selectedSale ? selectedSale.ma_nv : "";

        const updated = { ...record, tuyen_sale, ma_nv };
        try {
            const res = await ManagerService.CapNhatCongNo(record.ma_hd, updated);
            if (res.success !== false) {
                const updatedData = data.map(item =>
                    item.ma_hd === record.ma_hd ? updated : item
                );
                setData(updatedData);
                setFilteredData(updatedData);
                message.success("Cập nhật thành công");

                // ✅ Cập nhật lại cellValue nếu đang edit 1 ô hiển thị (optional)
                if (editingCell?.dataIndex === "ma_nv" && editingCell.key === record.ma_hd) {
                    setCellValue(ma_nv);
                }
            } else {
                message.error("Cập nhật thất bại");
            }
        } catch {
            message.error("Có lỗi khi cập nhật");
        } finally {
            setEditingCell(null);
        }
    };
 
    {/* Khi người dùng chọn Mã KH, tự động cập nhật Tên đơn vị */}
    // Dùng cho chế độ Edit cả dòng
    const handleCustomerChangeRow = (value) => {
        const selectedKh = dsKhachHang.find(kh => kh.ma_khach_hang === value);
        setEditedValues({
            ...editedValues,
            ma_khach_hang: value,
            ten_don_vi: selectedKh ? selectedKh.ten_don_vi : ""
        });
    };
    // Dùng cho chế độ Edit từng ô (cell)
    const handleCustomerChangeCell = async (record, ma_khach_hang) => {
        const selectedKh = dsKhachHang.find(kh => kh.ma_khach_hang === ma_khach_hang);
        const ten_don_vi = selectedKh ? selectedKh.ten_don_vi : "";
    
        const updated = { ...record, ma_khach_hang, ten_don_vi };
        try {
            const res = await ManagerService.CapNhatCongNo(record.ma_hd, updated);
            if (res.success !== false) {
                const updatedData = data.map(item =>
                    item.ma_hd === record.ma_hd ? updated : item
                );
                setData(updatedData);
                setFilteredData(updatedData);
                message.success("Cập nhật thành công");

                // ✅ Cập nhật lại cellValue nếu đang edit 1 ô hiển thị (optional)
                if (editingCell?.dataIndex === "ten_don_vi" && editingCell.key === record.ma_hd) {
                    setCellValue(ten_don_vi);
                }
            } else {
                message.error("Cập nhật thất bại");
            }
        } catch {
            message.error("Có lỗi khi cập nhật");
        } finally {
            setEditingCell(null);
        }
    };

    //Các hàm sử lý khi thay đổi chỉnh sửa đơn công nợ
    const isEditing = (record) => record.ma_hd === editingKey;
    const edit = (record) => {
        const { ky_ps, ...rest } = record;
        const ky_ps_formatted = ky_ps ? moment(ky_ps, "YYYY-MM-DD").format("MM/YYYY") : "";
        setEditingKey(record.ma_hd);
        setEditedValues({ ...rest, ky_ps: ky_ps_formatted }); // Chuyển format đúng
    };
    const handleInputChange = (value, key) => {
        setEditedValues({ ...editedValues, [key]: value });
    };
    const saveEdit = async () => {
        try {
            const newValues = { ...editedValues };

            // ✅ Nếu có ky_ps thì chuẩn hóa định dạng
            if (newValues.ky_ps) {
                const parsed =
                    moment(newValues.ky_ps, "YYYY-MM-DD", true).isValid()
                        ? moment(newValues.ky_ps, "YYYY-MM-DD", true)
                        : moment(newValues.ky_ps, "MM/YYYY", true);
            
                if (!parsed.isValid()) {
                    message.error("Ngày không hợp lệ. Định dạng đúng: MM/YYYY hoặc YYYY-MM-DD");
                    return;
                }
            
                newValues.ky_ps = parsed.startOf("month").format("YYYY-MM-DD");
            }                     

            const response = await ManagerService.CapNhatCongNo(editingKey, newValues);
            message.success("Cập nhật dữ liệu thành công!");

            const updatedData = data.map((item) => {
                if (item.ma_hd === editingKey) {
                    const updated = { ...item, ...newValues }; // ✅ Dùng newValues thay vì editedValues
                    if (response.cong_no_ton !== undefined) {
                        updated.cong_no_ton = response.cong_no_ton;
                    }
                    return updated;
                }
                return item;
            });
            

            setData(updatedData);
            setFilteredData(updatedData);
            setEditingKey(null);
            console.log("Dữ liệu đã chỉnh sửa:", newValues);
        } catch (error) {
            message.error("Lỗi khi cập nhật dữ liệu!");
        }
    };        

    // Hàm lọc dữ liệu theo cột
    const handleSearch = debounce((value, dataIndex) => {
        setFilteredData(data.filter(item => 
            item[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase())
        ));
    }, 300);

    const exportToExcel = () => {
        // Chuyển đổi dữ liệu với tên cột bằng tiếng Việt
        const formattedData = data.map(item => ({
            "Mã hợp đồng": item.ma_hd,
            "Đơn vị": item.don_vi,
            "Kỳ phát sinh": moment(item.ky_ps).format("DD/MM/YYYY"), // Định dạng ngày
            "Dịch vụ": item.dich_vu,
            "Mã nhân viên": item.ma_nv,
            "Tuyến Sale": item.tuyen_sale,
            "Mã khách hàng": item.ma_khach_hang,
            "Tên đơn vị": item.ten_don_vi,
            "Tổng công nợ": item.tong_cong_no ? item.tong_cong_no.toLocaleString() + " VND" : "0 VND",
            "Công nợ còn lại": item.cong_no_ton ? item.cong_no_ton.toLocaleString() + " VND" : "0 VND",
            "Giải trình": item.giai_trinh,
        }));
    
        // Tạo worksheet và workbook
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = XLSX.utils.book_new();

        // Cố định tiêu đề
        XLSX.utils.sheet_add_aoa(ws, [columns.map(col => col.title)], { origin: "A1" });

        // Tự động căn chỉnh chiều rộng cột
        const columnWidths = columns.map(col => ({
            wch: Math.max(10, col.title.length + 5), // Đảm bảo tiêu đề không bị cắt
        }));
        ws["!cols"] = columnWidths;

        XLSX.utils.book_append_sheet(wb, ws, "CongNo");
    
        // Lấy ngày hiện tại để đặt tên file
        const today = moment().format("YYYYMMDD");
        const fileName = `DanhSachCongNo_${today}.xlsx`;

        // Xuất file Excel
        XLSX.writeFile(wb, fileName);
    };
    
    const handleFilterChange = () => {
        let filtered = [...data];
    
        if (selectedKyPs) {
            filtered = filtered.filter((item) => item.ky_ps === selectedKyPs);
        }
    
        if (selectedDichVu) {
            filtered = filtered.filter((item) => item.dich_vu === selectedDichVu);
        }
    
        setFilteredData(filtered);
    };
    
    // Cập nhật filter khi giá trị thay đổi
    useEffect(() => {
        if (!selectedKyPs && !selectedDichVu) return;
        handleFilterChange();
    }, [selectedKyPs, selectedDichVu]);
    

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Tìm kiếm`}
                    value={selectedKeys[0]}
                    onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        handleSearch(e.target.value, dataIndex);
                    }}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
            </div>
        ),
    });

    const [editingCell, setEditingCell] = useState(null);
    const [cellValue, setCellValue] = useState("");
    //Hàm xử lý tiến hành edit khi nhấp chuột trái 2 lần vào ô
    const handleDoubleClick = (record, dataIndex) => {
        let value = record[dataIndex];
    
        if (dataIndex === "ky_ps" && value) {
            const parsed = moment(value, "YYYY-MM-DD", true);
            value = parsed.isValid() ? parsed.format("MM/YYYY") : "";
        }        
    
        setEditingCell({ key: record.ma_hd, dataIndex });
        setCellValue(value);
    };    
    const handleCellKeyDown = async (e, record) => {
        const cellKey = editingCell?.key;
        const dataIndex = editingCell?.dataIndex;
    
        if (e.key === "Enter") {
            let valueToSend = cellValue;
    
            if (dataIndex === "ky_ps") {
                const parsed = moment(cellValue, ["MM/YYYY", "YYYY-MM-DD"], true);
                if (!parsed.isValid()) {
                    message.error("Ngày không hợp lệ. Định dạng MM/YYYY hoặc YYYY-MM-DD");
                    return;
                }
                valueToSend = parsed.startOf("month").format("YYYY-MM-DD");
            }
    
            try {
                const updated = {
                    ...record,
                    [dataIndex]: valueToSend,
                };
    
                const res = await ManagerService.CapNhatCongNo(cellKey, updated); // ✅ dùng `cellKey` chính xác
                if (res.success !== false) {
                    const updatedData = data.map(item =>
                        item.ma_hd === cellKey
                            ? { ...item, [dataIndex]: valueToSend }
                            : item
                    );
                    setData(updatedData);
                    setFilteredData(updatedData);
                    message.success("Cập nhật thành công");
                } else {
                    message.error("Cập nhật thất bại");
                }
            } catch {
                message.error("Có lỗi khi cập nhật");
            } finally {
                setEditingCell(null);
            }
        } else if (e.key === "Escape") {
            setEditingCell(null);
        }
    };
     
    
    const renderEditableCell = (dataIndex) => (text, record) => {
        const isEditing = editingCell?.key === record.ma_hd && editingCell?.dataIndex === dataIndex;
        return isEditing ? (
            <Input
                value={cellValue}
                autoFocus
                onChange={(e) => setCellValue(e.target.value)}
                onKeyDown={(e) => handleCellKeyDown(e, record)}
                onBlur={() => setEditingCell(null)}
            />
        ) : (
            <div onDoubleClick={() => handleDoubleClick(record, dataIndex)} style={{ cursor: "pointer" }}>
                {text}
            </div>
        );
    };

    const columns = [
        {
            title: "Mã hợp đồng",
            dataIndex: "ma_hd",
            key: "ma_hd",
            width: 50,
            editable: true,
            ...getColumnSearchProps("ma_hd"),
            render: (text, record) => 
                isEditing(record) ? (
                    <Input
                        value={editedValues.ma_hd}
                        onChange={(e) => handleInputChange(e.target.value, "ma_hd")}
                        onPressEnter={saveEdit}
                        style={{ width: "100%" }}
                    />
                ) : (
                    <Tooltip title="Xem chi tiết hợp đồng">
                        <Button type="link" icon={<InfoCircleOutlined />} onClick={() => showModal(record)}>    {/*showModal(record)}>*/}
                            {text}
                        </Button>
                    </Tooltip>
                ),
        },
        {
            title: "Đơn vị",
            dataIndex: "don_vi",
            key: "don_vi",
            width: 80,
            editable: true,
            ...getColumnSearchProps("don_vi"),           
        },
        {
            title: "Kỳ phát sinh",
            dataIndex: "ky_ps",
            key: "ky_ps",
            width: 100,
            editable: true,
            render: (text, record) => {
                const isRowEditing = isEditing(record);
                const isCellEditing = editingCell?.key === record.ma_hd && editingCell?.dataIndex === "ky_ps";
                const isActive = isRowEditing || isCellEditing;
            
                const rawValue = isRowEditing ? editedValues.ky_ps : isCellEditing ? cellValue : record.ky_ps;
            
                // ✅ Parse lại value một cách chắc chắn
                let momentValue = null;
                if (typeof rawValue === "string") {
                    const parts = rawValue.split("/");
                    if (parts.length === 2) {
                        const [month, year] = parts;
                        if (!isNaN(month) && !isNaN(year)) {
                            momentValue = moment(`${year}-${month}-01`, "YYYY-MM-DD");
                        }
                    } else {
                        momentValue = moment(rawValue, "YYYY-MM-DD", true);
                    }
                } else if (moment.isMoment(rawValue)) {
                    momentValue = rawValue;
                }

                let initialMomentValue = null;
                if (manualInputKyPs && moment(manualInputKyPs, "MM/YYYY", true).isValid()) {
                    initialMomentValue = moment(manualInputKyPs, "MM/YYYY");
                } else if (rawValue && moment(rawValue, "MM/YYYY", true).isValid()) {
                    initialMomentValue = moment(rawValue, "MM/YYYY");
                } else if (rawValue && moment(rawValue, "YYYY-MM-DD", true).isValid()) {
                    initialMomentValue = moment(rawValue, "YYYY-MM-DD");
                }
            
                return isActive ? (
                    <DatePicker
                        picker="month"
                        value={initialMomentValue}
                        format="MM/YYYY"
                        style={{ width: "100%" }}
                        allowClear
                        disabledDate={(current) => {
                            const now = moment();
                            return current < now.clone().subtract(5, "years").startOf("month");
                        }}
                        onChange={async (date) => {
                            if (!date) return;
                            const formatted = date.startOf("month").format("YYYY-MM-DD");

                            if (isRowEditing) {
                                handleInputChange(formatted, "ky_ps");
                            } else {
                                setCellValue(formatted);
                                const updated = { ...record, ky_ps: formatted };
                                try {
                                    const res = await ManagerService.CapNhatCongNo(record.ma_hd, updated);
                                    if (res.success !== false) {
                                        const updatedData = data.map((item) =>
                                            item.ma_hd === record.ma_hd ? { ...item, ky_ps: formatted } : item
                                        );
                                        setData(updatedData);
                                        setFilteredData(updatedData);
                                        message.success("Cập nhật thành công");
                                    } else {
                                        message.error("Cập nhật thất bại");
                                    }
                                } catch {
                                    message.error("Có lỗi khi cập nhật");
                                } finally {
                                    setEditingCell(null);
                                    setManualInputKyPs("");
                                }
                            }
                        }}
                        onBlur={() => {
                            if (!isRowEditing && manualInputKyPs) {
                                const parsed = moment(manualInputKyPs, "MM/YYYY", true);
                                if (parsed.isValid()) {
                                    const formatted = parsed.startOf("month").format("YYYY-MM-DD");
                                    const updated = { ...record, ky_ps: formatted };
                                    ManagerService.CapNhatCongNo(record.ma_hd, updated).then((res) => {
                                        if (res.success !== false) {
                                            const updatedData = data.map((item) =>
                                                item.ma_hd === record.ma_hd ? { ...item, ky_ps: formatted } : item
                                            );
                                            setData(updatedData);
                                            setFilteredData(updatedData);
                                            message.success("Cập nhật thành công");
                                        } else {
                                            message.error("Cập nhật thất bại");
                                        }
                                    }).catch(() => {
                                        message.error("Có lỗi khi cập nhật");
                                    }).finally(() => {
                                        setEditingCell(null);
                                        setManualInputKyPs("");
                                    });
                                } else {
                                    message.error("Định dạng không hợp lệ (MM/YYYY)");
                                    setEditingCell(null);
                                    setManualInputKyPs("");
                                }
                            }
                        }}
                        onInput={(e) => setManualInputKyPs(e.target.value)}
                        inputReadOnly={false}
                    />
                ) : (
                    <div
                        onDoubleClick={() => handleDoubleClick(record, "ky_ps")}
                        style={{ cursor: "pointer" }}
                    >
                        {record.ky_ps ? moment(record.ky_ps, "YYYY-MM-DD").format("MM/YYYY") : "N/A"}
                    </div>
                );
            }                         
        },                        
        {
            title: "Dịch vụ",
            dataIndex: "dich_vu",
            key: "dich_vu",
            width: 150,
            editable: true,
            render: (text, record) => {
                const isRowEditing = isEditing(record); // Dùng nút Edit
                const isCellEditing = editingCell?.key === record.ma_hd && editingCell?.dataIndex === "dich_vu"; // Dùng double click
                const isActive = isRowEditing || isCellEditing;
            
                return isActive ? (
                    <Input
                        value={isRowEditing ? editedValues.dich_vu : cellValue}
                        autoFocus={isCellEditing}
                        onChange={(e) => {
                            isRowEditing
                                ? handleInputChange(e.target.value, "dich_vu")
                                : setCellValue(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            isRowEditing
                                ? e.key === "Enter" && saveEdit()
                                : handleCellKeyDown(e, record);
                        }}
                        onBlur={() => !isRowEditing && setEditingCell(null)}
                        style={{ width: "100%" }}
                    />
                ) : (
                    <div onDoubleClick={() => handleDoubleClick(record, "dich_vu")} style={{ cursor: "pointer" }}>
                        {text}
                    </div>
                );
            }            
        },
        {
            title: "Mã nhân viên",
            dataIndex: "ma_nv",
            key: "ma_nv",
            width: 120,
            editable: true,
            ...getColumnSearchProps("ma_nv"),
        },        
        {
            title: "Tuyến sale",
            dataIndex: "tuyen_sale",
            key: "tuyen_sale",
            width: 200,
            editable: true,
            ...getColumnSearchProps("tuyen_sale"),
            render: (text, record) => {
                const isRowEditing = isEditing(record);
                const isCellEditing = editingCell?.key === record.ma_hd && editingCell?.dataIndex === "tuyen_sale";
                const isActive = isRowEditing || isCellEditing;
        
                return isActive ? (
                    <Select
                        showSearch
                        style={{ width: "100%" }}
                        value={isRowEditing ? editedValues.tuyen_sale : cellValue}
                        onChange={(value) => {
                            if (isRowEditing) {
                                handleTuyenSaleChangeRow(value); // Cập nhật `editedValues`
                            } else {
                                setCellValue(value);
                                handleTuyenSaleChangeCell(record, value);
                            }
                        }}
                        onBlur={() => !isRowEditing && setEditingCell(null)}
                        autoFocus={isCellEditing}
                    >
                        {Ds_nv.map(nv => (
                            <Select.Option key={nv.tuyen_sale} value={nv.tuyen_sale}>
                                {nv.tuyen_sale}
                            </Select.Option>
                        ))}
                    </Select>
                ) : (
                    <div onDoubleClick={() => handleDoubleClick(record, "tuyen_sale")} style={{ cursor: "pointer" }}>
                        {text}
                    </div>
                );
            }
        },        
        {
            title: "Mã Khách hàng EVTP",
            dataIndex: "ma_khach_hang",
            key: "ma_khach_hang",
            width: 120,
            render: (text, record) => {
                const isRowEditing = isEditing(record);
                const isCellEditing = editingCell?.key === record.ma_hd && editingCell?.dataIndex === "ma_khach_hang";
                const isActive = isRowEditing || isCellEditing;
        
                return isActive ? (
                    <Select
                        showSearch
                        style={{ width: "100%" }}
                        value={isRowEditing ? editedValues.ma_khach_hang : cellValue}
                        onChange={(value) => {
                            if (isRowEditing) {
                                handleCustomerChangeRow(value); // Cập nhật `editedValues`
                            } else {
                                setCellValue(value);
                                handleCustomerChangeCell(record, value);
                            }
                        }}
                        onBlur={() => !isRowEditing && setEditingCell(null)}
                        autoFocus={isCellEditing}
                    >
                        {dsKhachHang.map(kh => (
                            <Select.Option key={kh.ma_khach_hang} value={kh.ma_khach_hang}>
                                {kh.ma_khach_hang}
                            </Select.Option>
                        ))}
                    </Select>
                ) : (
                    <div onDoubleClick={() => handleDoubleClick(record, "ma_khach_hang")} style={{ cursor: "pointer" }}>
                        {text}
                    </div>
                );
            }
        },        
        { 
            title: "Tên đơn vị", 
            dataIndex: "ten_don_vi", 
            key: "ten_don_vi", 
            width: 200,
            editable: true,
            ...getColumnSearchProps("ten_don_vi"),
        },
        {
            title: "Tổng công nợ",
            dataIndex: "tong_cong_no",
            key: "tong_cong_no",
            align: "right",
            width: 100,
            editable: true,
            render: (text, record) => {
              const isRowEditing = isEditing(record);
              const isCellEditing = editingCell?.key === record.ma_hd && editingCell?.dataIndex === "tong_cong_no";
              const isActive = isRowEditing || isCellEditing;
          
              const formattedValue = text != null ? parseFloat(text).toLocaleString() : "0";
          
              return isActive ? (
                <Input
                  type="number"
                  value={isRowEditing ? editedValues.tong_cong_no : cellValue}
                  autoFocus={isCellEditing}
                  onChange={(e) => {
                    isRowEditing
                      ? handleInputChange(e.target.value, "tong_cong_no")
                      : setCellValue(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    isRowEditing
                      ? e.key === "Enter" && saveEdit()
                      : handleCellKeyDown(e, record);
                  }}
                  onBlur={() => !isRowEditing && setEditingCell(null)}
                  style={{ width: "100%" }}
                />
              ) : (
                <div onDoubleClick={() => handleDoubleClick(record, "tong_cong_no")} style={{ cursor: "pointer" }}>
                  {formattedValue} VND
                </div>
              );
            }
        },        
        {
            title: "Phân loại",
            dataIndex: "phan_loai",
            key: "phan_loai",
            width: 100,
            editable: true,
            ...getColumnSearchProps("phan_loai"),
            render: (text, record) => {
                const isRowEditing = isEditing(record);
                const isCellEditing = editingCell?.key === record.ma_hd && editingCell?.dataIndex === "phan_loai";
                const isActive = isRowEditing || isCellEditing;
        
                return isActive ? (
                    <Input
                        value={isRowEditing ? editedValues.phan_loai : cellValue}
                        autoFocus={isCellEditing}
                        onChange={(e) => {
                            isRowEditing
                                ? handleInputChange(e.target.value, "phan_loai")
                                : setCellValue(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            isRowEditing
                                ? e.key === "Enter" && saveEdit()
                                : handleCellKeyDown(e, record);
                        }}
                        onBlur={() => !isRowEditing && setEditingCell(null)}
                        style={{ width: "100%" }}
                    />
                ) : (
                    <div onDoubleClick={() => handleDoubleClick(record, "phan_loai")} style={{ cursor: "pointer" }}>
                        {text}
                    </div>
                );
            }
        }, 
        {
            title: "Thời hạn",
            key: "thoi_han",
            width: 100,
            render: (text, record) => {
                const kyPsDate = moment(record.ky_ps, "YYYY-MM-DD");
                const soNgay = record.thoi_han_cong_no || 0;
                const ngayHetHan = kyPsDate.clone().add(soNgay, 'days');
                const ngayHienTai = moment();
                const daysLeft = ngayHetHan.diff(ngayHienTai, 'days');
        
                if (isNaN(daysLeft)) return "N/A";
                if (daysLeft < 0) return <Tag color="red">{Math.abs(daysLeft)} ngày trễ</Tag>;
                return <Tag color={daysLeft <= 7 ? "orange" : "green"}>{daysLeft} ngày</Tag>;
            }
        },               
        {
            title: "Công nợ còn lại",
            dataIndex: "cong_no_ton",
            key: "cong_no_ton",
            align: "right",
            width: 100,
            editable: true,
            render: (text, record) => {
              const value = text != null ? parseFloat(text).toLocaleString() : "0";
              const color = parseFloat(text) <= 0 ? "green" : "red";
              return <Tag color={color}>{value} VND</Tag>;
            }
        },          
        {
            title: "Giải trình",
            dataIndex: "giai_trinh",
            key: "giai_trinh",
            width: 150,
            editable: true,
        },
        {
            title: "Thao tác",
            width: 120,
            editable: true,
            render: (_, record) =>
                isEditing(record) ? (
                    <Button
                        type="link"
                        icon={<CheckOutlined />}
                        onClick={saveEdit}
                    />
                ) : (
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => edit(record)}
                    />
                ),
        },
    ];

    {/* Các hàm liên quan đến việc hiển thị các cột mong muốn*/}
    const toggleColumnVisibility = (column) => {
        setVisibleColumns((prev) =>
            prev.includes(column) ? prev.filter((col) => col !== column) : [...prev, column]
        );
    };

    const applyColumnVisibilityChanges = () => {
        setVisibleColumns([...visibleColumns]);
    };

    {/* Hiển thị dropdown */}
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const columnMenuContent = (
        <div style={{ padding: 10, background: "#fff", borderRadius: 4, boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}>
            <Checkbox
                checked={visibleColumns.length === columns.length}
                onChange={() => setVisibleColumns(columns.map((col) => col.key))}
            >
                Chọn tất cả
            </Checkbox>
            <br />
            <Checkbox
                checked={visibleColumns.length === 0}
                onChange={() => setVisibleColumns([])}
            >
                Bỏ chọn tất cả
            </Checkbox>
            <Divider style={{ margin: "8px 0" }} />
            {columns.map((col) => (
                <div key={col.key} style={{ marginBottom: 4 }}>
                    <Checkbox
                        checked={visibleColumns.includes(col.key)}
                        onChange={() => toggleColumnVisibility(col.key)}
                    >
                        {col.title}
                    </Checkbox>
                </div>
            ))}
            <Button
                type="primary"
                onClick={() => {
                    applyColumnVisibilityChanges();
                    setDropdownVisible(false); // ✅ Đóng dropdown
                }}
                style={{ marginTop: 10, width: "100%" }}
            >
                Xác nhận
            </Button>
        </div>
    );
    const columnDropdown = (
        <Dropdown
            visible={dropdownVisible}
            onVisibleChange={(visible) => setDropdownVisible(visible)}
            dropdownRender={() => columnMenuContent}
            trigger={["click"]}
        >
            <Button icon={<SettingOutlined />} style={{ marginBottom: 10 }}>
                Chọn cột hiển thị
            </Button>
        </Dropdown>
    );
    
    {/* Nội dung dành cho Modal chi tiết đơn công nợ */}
    const [editingRowKey, setEditingRowKey] = useState(null);
    const [editedThanhToan, setEditedThanhToan] = useState({});

    //Lấy lịch sử thanh toán của 1 đơn công nợ
    const fetchLichSuThanhToan = async (maHd) => {
        setLoadingPaymentHistory(true);
        try {
            const response = await ManagerService.getLichSuThanhToanCongNo(maHd);
            setLichSuThanhToan(response.data);
        } catch (error) {
            console.error("Lỗi khi lấy lịch sử thanh toán:", error);
        } finally {
            setLoadingPaymentHistory(false);
        }
    };

    //Modal Chi tiết Đơn công nợ
    const showModal = (record) => {
        setSelectedRecord(record);
        setSoTienThanhToan(""); 
        setIsPaying(false);
        fetchLichSuThanhToan(record.ma_hd);
        setModalVisible(true);
    };
    const [loadingPaymentHistory, setLoadingPaymentHistory] = useState(false);

    //Thanh toán công nợ
    const handleThanhToan = () => {
        if (selectedRecord.cong_no_ton === 0) {
            message.info("Công nợ đã thanh toán hết.");
        } else {
            setIsPaying(true);
        }
    };
    
    //Lưu lịch sử thanh toán
    const [savingPayment, setSavingPayment] = useState(false);
    const handleLuuThanhToan = async () => {
        const soTien = parseFloat(soTienThanhToan);
    
        if (isNaN(soTien) || soTien <= 0) {
            message.error("Vui lòng nhập số tiền hợp lệ.");
            return;
        }
    
        if (soTien > selectedRecord.cong_no_ton) {
            message.error("Số tiền thanh toán không được vượt quá công nợ còn lại.");
            return;
        }
    
        try {
            setSavingPayment(true);
    
            // 🔹 Kiểm tra xem đã có thanh toán trong ngày chưa
            const today = moment().format("YYYY-MM-DD");
            const existingPayment = lichSuThanhToan.find(item => moment(item.ngay_tt).format("YYYY-MM-DD") === today);
    
            if (existingPayment) {
                // ✅ Nếu đã có thanh toán trong ngày → Cộng dồn số tiền mới
                const updatedSoTien = parseFloat(existingPayment.so_tien) + soTien; // 🔹 Đảm bảo `so_tien` được định nghĩa
                await ManagerService.capNhatLichSuThanhToan({
                    ma_hd: selectedRecord.ma_hd,
                    ngay_tt: today,
                    so_tien: updatedSoTien
                });
    
                // ✅ Cập nhật ngay trong lịch sử modal
                setLichSuThanhToan(prev =>
                    prev.map(item =>
                        moment(item.ngay_tt).format("YYYY-MM-DD") === today
                            ? { ...item, so_tien: updatedSoTien }
                            : item
                    )
                );
            } else {
                // ✅ Nếu chưa có thanh toán trong ngày → Thêm mới bản ghi
                await ManagerService.thanhToanCongNo(selectedRecord.ma_hd, soTien, today);
                setLichSuThanhToan(prev => [
                    ...prev,
                    { ngay_tt: today, so_tien: soTien } // 🔹 Đảm bảo `so_tien` có giá trị hợp lệ
                ]);
            }
    
            message.success("Thanh toán thành công!");
    
            // 🔹 Cập nhật công nợ còn lại
            const newCongNoTon = selectedRecord.cong_no_ton - soTien;
            setSelectedRecord(prev => ({ ...prev, cong_no_ton: newCongNoTon }));
    
            // 🔹 Cập nhật lại danh sách công nợ
            const updatedData = data.map(item =>
                item.ma_hd === selectedRecord.ma_hd
                    ? { ...item, cong_no_ton: newCongNoTon }
                    : item
            );
    
            setData(updatedData);
            setFilteredData(updatedData);
            setSoTienThanhToan("");
            setIsPaying(false);
        } catch (error) {
            message.error("Lỗi khi thanh toán: " + error.message);
        } finally {
            setSavingPayment(false);
        }
    };    
    
    //Lưu lại Số tiền thanh toán đã bị thay đổi
    const handleSaveSoTienThanhToan = async (record) => {
        const ma_hd = selectedRecord.ma_hd;
        const ngay_tt = moment(record.ngay_tt).format("YYYY-MM-DD");
        const so_tien = Number(editedThanhToan.so_tien);
    
        if (!ma_hd || !ngay_tt || isNaN(so_tien) || so_tien < 0) {
            message.error("Dữ liệu không hợp lệ khi cập nhật.");
            return;
        }
    
        try {
            const res = await ManagerService.capNhatLichSuThanhToan({ ma_hd, ngay_tt, so_tien });
    
            if (res.success) {
                message.success("Cập nhật số tiền thành công!");
                const newCongNoTon = res.cong_no_ton;
    
                // Cập nhật lịch sử thanh toán trong modal
                setLichSuThanhToan((prev) =>
                    prev.map((item) =>
                        moment(item.ngay_tt).format("YYYY-MM-DD") === ngay_tt ? { ...item, so_tien } : item
                    )
                );
    
                // Cập nhật công nợ tồn trong chi tiết modal
                setSelectedRecord((prev) => ({
                    ...prev,
                    cong_no_ton: newCongNoTon
                }));
    
                // Cập nhật công nợ tồn trong bảng chính
                setData((prevData) =>
                    prevData.map((item) =>
                        item.ma_hd === ma_hd ? { ...item, cong_no_ton: newCongNoTon } : item
                    )
                );
                setFilteredData((prevData) =>
                    prevData.map((item) =>
                        item.ma_hd === ma_hd ? { ...item, cong_no_ton: newCongNoTon } : item
                    )
                );
    
                setEditingRowKey(null);
                setEditedThanhToan({});
            } else {
                throw new Error(res.message);
            }
        } catch (error) {
            message.error("Lỗi khi cập nhật số tiền.");
        }
    };        

    return (
        <div>
            <h2>Quản Lý Công Nợ</h2>

            <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                <Select
                    placeholder="Chọn kỳ phát sinh"
                    style={{ width: 200 }}
                    value={selectedKyPs}
                    onChange={(value) => {
                        setSelectedKyPs(value);
                        handleFilterChange();
                    }}
                    allowClear
                >
                    {[...new Set(data.map((item) => item.ky_ps))].map((ky) => (
                        <Select.Option key={ky} value={ky}>
                            {moment(ky, "YYYY-MM-DD").format("MM/YYYY")}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    placeholder="Chọn dịch vụ"
                    style={{ width: 200 }}
                    value={selectedDichVu}
                    onChange={(value) => {
                        setSelectedDichVu(value);
                        handleFilterChange();
                    }}
                    allowClear
                >
                    {[...new Set(data.map((item) => item.dich_vu))].map((dv) => (
                        <Select.Option key={dv} value={dv}>{dv}</Select.Option>
                    ))}
                </Select>
            </div>
            <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                {columnDropdown}
                <Button icon={<FileExcelOutlined />} onClick={() => exportToExcel()}>
                    Xuất Excel
                </Button>
            </div>
            {/* Thêm hướng dẫn thao tác */}
            <div style={{
                padding: "8px 12px",
                background: "#f5f5f5",
                borderRadius: "6px",
                borderLeft: "4px solid #1890ff",
                fontSize: "14px",
                color: "#333",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "10px"
            }}>
                <InfoCircleOutlined style={{ color: "#1890ff" }} />
                <span>
                    Nhấn <strong>chuột 2 lần</strong> vào ô để chỉnh sửa nhanh hoặc sử dụng <strong>nút Edit</strong> để chỉnh sửa cả dòng.
                </span>
            </div>

            <Table
                columns={columns.filter((col) => !col.key || visibleColumns.includes(col.key))}
                dataSource={filteredData}
                loading={loading}
                rowKey="ma_hd"
                bordered
                pagination={{ pageSize: 10 }}
                scroll={{ x: 1000 }}
            />


            {/* Hiển thị chi tiết thông tin Công nợ*/}
            <Modal
                title="Chi Tiết Công Nợ"
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={null}
                width={900}
            >
                {selectedRecord && (
                    <Card style={{ border: "1px solid black", marginBottom: "20px" }}>
                        <Row gutter={16}>
                            <Col span={12}><p><strong>Mã hợp đồng:</strong> {selectedRecord.ma_hd}</p></Col>
                            <Col span={12}><p><strong>Đơn vị:</strong> {selectedRecord.don_vi}</p></Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}><p><strong>Kỳ phát sinh:</strong> {moment(selectedRecord.ky_ps).format("DD/MM/YYYY")}</p></Col>
                            <Col span={12}><p><strong>Dịch vụ:</strong> {selectedRecord.dich_vu}</p></Col>
                        </Row>

                        <Row gutter={16} style={{ display: "flex" }}>
                            <Col span={12}><p><strong>Mã nhân viên:</strong> {selectedRecord.ma_nv}</p></Col>
                            <Col span={12}><p><strong>Tuyến Sale:</strong> {selectedRecord.tuyen_sale}</p></Col>
                        </Row>

                        <Row gutter={16} style={{ display: "flex" }}>
                            <Col span={12}><p><strong>Mã khách hàng:</strong> {selectedRecord.ma_khach_hang}</p></Col>
                            <Col span={12}>
                                <p style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    <strong>Tên đơn vị:</strong> {selectedRecord.ten_don_vi}
                                </p>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}><p><strong>Tổng công nợ:</strong> {(selectedRecord.tong_cong_no || 0).toLocaleString()} VND</p></Col>
                            <Col span={12}><p><strong>Phân loại:</strong> {selectedRecord.phan_loai}</p></Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <p>
                                    <strong>Công nợ còn lại:</strong> 
                                    <Tag color={selectedRecord.cong_no_ton > 0 ? "red" : "green"}>
                                        {(selectedRecord.cong_no_ton || 0).toLocaleString()} VND
                                    </Tag>
                                </p>
                            </Col>
                        </Row>
                    </Card>
                )}

                <p><strong>Lịch Sử Thanh Toán</strong></p>
                <DatePicker
                    onChange={(date, dateString) => setFilterDate(dateString)}
                    placeholder="Lọc theo ngày"
                    style={{ marginTop: 10, marginRight: 10 }}
                />

                <Input
                    type="number"
                    placeholder="Lọc số tiền thanh toán"
                    onChange={(e) => setFilterSoTien(e.target.value)}
                    style={{ width: 200, marginTop: 10 }}
                />
                <Table
                    columns={[
                        {
                            title: "Ngày thanh toán",
                            dataIndex: "ngay_tt",
                            key: "ngay_tt",
                            render: (date) => moment(date).format("DD/MM/YYYY"),
                        },
                        {
                            title: "Số tiền",
                            dataIndex: "so_tien",
                            key: "so_tien",
                            render: (text, record) =>
                                editingRowKey === record.ngay_tt ? (
                                    <Input
                                        type="number"
                                        defaultValue={record.so_tien}
                                        onChange={(e) =>
                                            setEditedThanhToan({ ...record, so_tien: Number(e.target.value) })
                                        }
                                    />
                                ) : (
                                    `${text.toLocaleString()} VND`
                                ),
                        },
                        {
                            title: "Hành động",
                            key: "actions",
                            render: (_, record) =>
                                editingRowKey === record.ngay_tt ? (
                                    <Button type="link" onClick={() => handleSaveSoTienThanhToan(record)}>
                                        Lưu
                                    </Button>
                                ) : (
                                    <Button type="link" onClick={() => setEditingRowKey(record.ngay_tt)}>
                                        Sửa
                                    </Button>
                                ),
                        },
                    ]}
                    dataSource={lichSuThanhToan.filter(item =>
                        (!filterDate || moment(item.ngay_tt).format("YYYY-MM-DD") === filterDate) &&
                        (!filterSoTien || item.so_tien >= filterSoTien)
                    )}
                    rowKey="ngay_tt"
                    pagination={false}
                    loading={loadingPaymentHistory}
                />

                <Button type="primary" onClick={handleThanhToan} style={{ marginTop: "10px" }}>
                    Thanh toán
                </Button>
                {isPaying && (
                    <div style={{ marginTop: "10px" }}>
                        <Input
                            type="number"
                            placeholder="Nhập số tiền thanh toán"
                            value={soTienThanhToan}
                            onChange={(e) => setSoTienThanhToan(e.target.value)}
                        />
                        <Button type="primary" onClick={handleLuuThanhToan} loading={savingPayment} style={{ marginTop: "10px" }}>
                            Lưu
                        </Button>
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default QuanLyDonCongNoComponent;
